import React from 'react';

class Loading extends React.Component {
  render() {
    return (
      <div className="loading" data-testid="loading">Carregando</div>
    );
  }
}

export default Loading;
